import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { allTimePeriods, getTimePeriodText, IndicatorDetails } from '../utils';

interface TimePeriodButtonSmallProps {
  selected: IndicatorDetails['timePeriod'];
  handleChange: (
    timePeriod: NonNullable<IndicatorDetails['timePeriod']>,
  ) => unknown;
}

const StyledDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACERS.tiny};
  margin-top: ${SPACERS.tiny};
  button {
    flex: 1;
    cursor: pointer;
    max-width: 120px;
    padding: ${SPACERS.small} 10px;
    border-radius: ${SPACERS.extraTiny};
    border: 1px solid ${COLORS.grayBase};
    transition: background-color 0.3s ease-in-out;
    &:hover {
      background-color: ${COLORS.ctaPrimaryBackground};
    }
    .margin-top {
      margin-top: ${SPACERS.tiny};
    }
  }
  .active {
    color: ${COLORS.whiteBase} !important;
    background-color: ${COLORS.ctaPrimary} !important;
  }
`;

const TimePeriodButtonSmall: React.FC<TimePeriodButtonSmallProps> = ({
  selected,
  handleChange,
}) => {
  return (
    <StyledDiv>
      {allTimePeriods.map(t => {
        const isActive = selected === t;
        return (
          <button
            key={t}
            onClick={() => handleChange(t)}
            className={isActive ? 'active' : ''}
          >
            <TrueImpactText
              variant="body-small-bold"
              color={isActive ? 'whiteBase' : undefined}
            >
              {t}
            </TrueImpactText>
            <TrueImpactText
              variant="body-small"
              color={isActive ? 'whiteBase' : undefined}
              className="margin-top"
            >
              {getTimePeriodText(t)}
            </TrueImpactText>
          </button>
        );
      })}
    </StyledDiv>
  );
};

export default TimePeriodButtonSmall;
